// extracted by mini-css-extract-plugin
module.exports = {"button-back":"ButtonBack_button-back__3h-XV"};